// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FailedPayoutOrRefundModal-commonHeaderAdmin-GKfxU {
	position: fixed !important;
}

.FailedPayoutOrRefundModal-adminLayout-sKRO0 {
	padding-top: 64px !important;
}

.FailedPayoutOrRefundModal-box-L6l2g h2 {
	font-size: 21px;
	font-weight: 600;
}

.FailedPayoutOrRefundModal-exportLink-JHwR0 {
	margin-bottom: -29px;
}

.FailedPayoutOrRefundModal-blockCenter-vBEE5 {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.FailedPayoutOrRefundModal-panelHeader-X8EoT {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.FailedPayoutOrRefundModal-currencyselect-H_NO1 {
	width: 100%;
	margin-right: 0px;
}

.FailedPayoutOrRefundModal-panelHeader-X8EoT {
	overflow: hidden;
	position: relative;
}

.FailedPayoutOrRefundModal-mar0-cwebm {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.FailedPayoutOrRefundModal-blockCenter-vBEE5 {
		padding: 0px;
	}

	.FailedPayoutOrRefundModal-panelHeader-X8EoT {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.FailedPayoutOrRefundModal-sideAdminPageWrapper-gaQFf {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.FailedPayoutOrRefundModal-panelHeader-X8EoT {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.FailedPayoutOrRefundModal-table-V96TL {
	display: table;
}

.FailedPayoutOrRefundModal-tableRow-PRkGG {
	display: table-row;
}

.FailedPayoutOrRefundModal-tableCell-RFYXY {
	display: table-cell;
	float: none;
}

.FailedPayoutOrRefundModal-formGroup-GpyNg {
	margin-bottom: 6px;
}

.FailedPayoutOrRefundModal-select-KMmZV {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.FailedPayoutOrRefundModal-noMargin-h5tqk {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.FailedPayoutOrRefundModal-exportLink-JHwR0 {
	padding-top: 10px;
	padding-right: 10px;
}

.FailedPayoutOrRefundModal-labelTextNew-z8ATt {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.FailedPayoutOrRefundModal-displayInline-ygIen {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.FailedPayoutOrRefundModal-btnUPdate-ounIS {
	display: inline-block;
}

.FailedPayoutOrRefundModal-btnModalDelete-s8F7B {
	display: inline-block;
	margin-left: 15px;
}

.FailedPayoutOrRefundModal-radioBtn-spJ3V {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.FailedPayoutOrRefundModal-backgroundImg-KHmip {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.FailedPayoutOrRefundModal-btnUPdate-ounIS {
		display: block;
		margin-bottom: 12px;
	}

	.FailedPayoutOrRefundModal-btnModalDelete-s8F7B {
		display: block;
		margin-left: 0px;
	}

	.FailedPayoutOrRefundModal-btnWidth-KBftx {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.FailedPayoutOrRefundModal-bannerImageBg-bDpHq {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.FailedPayoutOrRefundModal-bannerDelete-ZE1zT {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.FailedPayoutOrRefundModal-modalRoot-ZSPfs {
	padding: 32px;
}

.FailedPayoutOrRefundModal-modalBorderBottom-k_IlY {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.FailedPayoutOrRefundModal-logInModalBody-_LD24 {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.FailedPayoutOrRefundModal-exportSection-hQFoz {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.FailedPayoutOrRefundModal-exportSectionGridSub-K7Kie {
	grid-template-columns: 50% 49% !important;
}

.FailedPayoutOrRefundModal-exportText-dK1KZ {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.FailedPayoutOrRefundModal-exportLinkImg-igvtr {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.FailedPayoutOrRefundModal-vtrMiddle-iEXXa {
	vertical-align: middle;
}

.FailedPayoutOrRefundModal-exportImg-srYoJ {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.FailedPayoutOrRefundModal-profileViewlabel-BzODQ {
	display: inline-block;
	width: 38%
}

.FailedPayoutOrRefundModal-profileViewMainContent-vcTb9 {
	display: inline-block;
	width: 62%;
}

.FailedPayoutOrRefundModal-profileViewMain-l0X3y {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.FailedPayoutOrRefundModal-profileViewInner-HMC4A {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.FailedPayoutOrRefundModal-profileImageSection-fwu5f {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.FailedPayoutOrRefundModal-lastviewInner-I8QDW {
	padding: 10px;
}

.FailedPayoutOrRefundModal-whyHostHoriLine-mfzir {
	margin: 30px 0;
}

.FailedPayoutOrRefundModal-tableGrid-VaxQW {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.FailedPayoutOrRefundModal-headingContent-tAdf0 {
	font-size: 18px;
	font-weight: 500;
}

.FailedPayoutOrRefundModal-refundTextColor-VPm43 {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.FailedPayoutOrRefundModal-dividerLine-sBqLP {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.FailedPayoutOrRefundModal-smallContent-sp0qF {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.FailedPayoutOrRefundModal-sideAdminPageWrapper-gaQFf {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.FailedPayoutOrRefundModal-sideAdminPageWrapper-gaQFf {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.FailedPayoutOrRefundModal-exportSection-hQFoz {
		grid-template-columns: 100%;
	}

	.FailedPayoutOrRefundModal-exportSectionGridSub-K7Kie {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.FailedPayoutOrRefundModal-profileViewlabel-BzODQ {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.FailedPayoutOrRefundModal-profileViewMainContent-vcTb9 {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.FailedPayoutOrRefundModal-ChangeToUpperCase-Da0cF {
	text-transform: uppercase
}

.FailedPayoutOrRefundModal-noBorder-cLwZe {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.FailedPayoutOrRefundModal-siteAdminHeading-IpHX4 {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.FailedPayoutOrRefundModal-siteAdminSubHeading-RnCW_ {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.FailedPayoutOrRefundModal-adminFormDivider-W9rbW {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.FailedPayoutOrRefundModal-space1-livLO {
	margin-bottom: 6px !important;
}

.FailedPayoutOrRefundModal-space2-lG3tE {
	margin-bottom: 12px !important;
}

.FailedPayoutOrRefundModal-space3-oNlK9 {
	margin-bottom: 18px !important;
}

.FailedPayoutOrRefundModal-space4-zLWpP {
	margin-bottom: 24px !important;
}

.FailedPayoutOrRefundModal-space5-zr4Gj {
	margin-bottom: 30px !important;
}

.FailedPayoutOrRefundModal-space6-Im_wj {
	margin-bottom: 36px !important;
}

.FailedPayoutOrRefundModal-space7-e1LKi {
	margin-bottom: 42px !important;
}

.FailedPayoutOrRefundModal-spaceTop8-kyDZu {
	margin-bottom: 48px !important;
}

.FailedPayoutOrRefundModal-spaceTop1-sBC_u {
	margin-top: 6px !important;
}

.FailedPayoutOrRefundModal-spaceTop2-q0m5v {
	margin-top: 12px !important;
}

.FailedPayoutOrRefundModal-spaceTop3-as0pA {
	margin-top: 18px !important;
}

.FailedPayoutOrRefundModal-spaceTop4-yn4AQ {
	margin-top: 24px !important;
}

.FailedPayoutOrRefundModal-spaceTop5-DbYk6 {
	margin-top: 30px !important;
}

.FailedPayoutOrRefundModal-spaceTop6-K1oOB {
	margin-top: 36px !important;
}

.FailedPayoutOrRefundModal-spaceTop7-eR8Dh {
	margin-top: 42px !important;
}

.FailedPayoutOrRefundModal-spaceTop8-kyDZu {
	margin-top: 48px !important;
}

.FailedPayoutOrRefundModal-noMargin-h5tqk {
	margin: 0px !important;
}

.FailedPayoutOrRefundModal-padding1-LY88x {
	padding-bottom: 6px !important;
}

.FailedPayoutOrRefundModal-padding2-K9JSH {
	padding-bottom: 12px !important;
}

.FailedPayoutOrRefundModal-padding3-rfeQs {
	padding-bottom: 18px !important;
}

.FailedPayoutOrRefundModal-padding4-FVm41 {
	padding-bottom: 24px !important;
}

.FailedPayoutOrRefundModal-padding5-HmNGI {
	padding-bottom: 30px !important;
}

.FailedPayoutOrRefundModal-padding6-ybtLU {
	padding-bottom: 36px !important;
}

.FailedPayoutOrRefundModal-padding7-zGhWM {
	padding-bottom: 42px !important;
}

.FailedPayoutOrRefundModal-paddingTop1-iERL0 {
	padding-top: 6px !important;
}

.FailedPayoutOrRefundModal-paddingTop2-S9zZz {
	padding-top: 12px !important;
}

.FailedPayoutOrRefundModal-paddingTop3-Fs5jD {
	padding-top: 18px !important;
}

.FailedPayoutOrRefundModal-paddingTop4-YkSFL {
	padding-top: 24px !important;
}

.FailedPayoutOrRefundModal-paddingTop5-eN5EH {
	padding-top: 30px !important;
}

.FailedPayoutOrRefundModal-paddingTop6-yJfYF {
	padding-top: 36px !important;
}

.FailedPayoutOrRefundModal-paddingTop7-vLlzi {
	padding-top: 42px !important;
}

.FailedPayoutOrRefundModal-noPadding-YOiox {
	padding: 0px !important;
}

.FailedPayoutOrRefundModal-textBold-yw0Ev {
	font-weight: 500 !important;
}

.FailedPayoutOrRefundModal-textBolder-F3mmm {
	font-weight: 700 !important;
}

.FailedPayoutOrRefundModal-textNormal-Qym3k {
	font-weight: normal !important;
}

.FailedPayoutOrRefundModal-spaceBottom20-xq_QU {
	margin-bottom: 20px;
}

.FailedPayoutOrRefundModal-spaceBottom10-UKIce {
	margin-bottom: 10px;
}

.FailedPayoutOrRefundModal-marginNone-E_pUx {
	margin: 0;
}

.FailedPayoutOrRefundModal-spaceBottom15-OaKWN {
	margin-bottom: 15px;
}

.FailedPayoutOrRefundModal-marginTopNone-gcjb9 {
	margin-top: 0;
}

.FailedPayoutOrRefundModal-spaceTop11-Dsqx0 {
	margin-top: 11px;
}

.FailedPayoutOrRefundModal-spaceTop21-f5lbj {
	margin-top: 21px;
}

.FailedPayoutOrRefundModal-spaceTop20-ORuk2 {
	margin-top: 20px;
}

.FailedPayoutOrRefundModal-spaceTop10-dkMDO {
	margin-top: 10px;
}

/*New Design Text Colors */

.FailedPayoutOrRefundModal-textDarkBlue-MSgkK {
	color: rgb(20, 39, 94) !important;
}

.FailedPayoutOrRefundModal-textLightBlue-An5JE {
	color: rgb(57, 87, 106) !important;
}

.FailedPayoutOrRefundModal-textLightSandleGreen-ifrAG {
	color: rgb(76, 86, 41) !important;
}

.FailedPayoutOrRefundModal-textLightBrown-ssRRj {
	color: rgb(115, 79, 33) !important;
}

.FailedPayoutOrRefundModal-textMediumMaroon-JEOyC {
	color: rgb(87, 37, 51) !important;
}

.FailedPayoutOrRefundModal-textBrown-FgeuE {
	color: rgb(160, 47, 24) !important;
}

.FailedPayoutOrRefundModal-textMaroon-YAV1c {
	color: rgb(155, 49, 67) !important;
}

.FailedPayoutOrRefundModal-textDarkBrown-OP9GS {
	color: rgb(83, 18, 16) !important;
}

.FailedPayoutOrRefundModal-textMediumBrown-joLPE {
	color: rgb(142, 28, 10) !important;
}

.FailedPayoutOrRefundModal-textSkyBlue-ZrEVM {
	color: rgb(37, 117, 141) !important;
}

.FailedPayoutOrRefundModal-textGray-YrlCN {
	color: rgb(77, 65, 51) !important;
}

.FailedPayoutOrRefundModal-logInModalContainer-dq1ow {
    max-width: 468px;
    width: 100%;
    margin: 160px auto;
  }

.FailedPayoutOrRefundModal-modalPadding-AYM5a {
    padding: 32px;
  }

.FailedPayoutOrRefundModal-paddingNone-uSDHF{
    padding: 0 !important;
  }

.FailedPayoutOrRefundModal-modalGrid-dyRIm{
    display: grid;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    word-break: break-word;
    grid-template-columns: 40% 60%;
    grid-column-gap: 8px;
  }

@media screen and (max-width: 767px) {
    .FailedPayoutOrRefundModal-logInModalContainer-dq1ow {
      margin: 0px auto;
      padding: 10px;
    }
    .FailedPayoutOrRefundModal-modalGrid-dyRIm{
      grid-template-columns: 100%;
      margin-bottom: 12px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/FailedPayoutOrRefundModal/FailedPayoutOrRefundModal.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;ACxNA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;EACpB;;AAEA;IACE,aAAa;EACf;;AACA;IACE,qBAAqB;EACvB;;AACA;IACE,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,sBAAsB;IACtB,8BAA8B;IAC9B,oBAAoB;EACtB;;AACA;IACE;MACE,gBAAgB;MAChB,aAAa;IACf;IACA;MACE,2BAA2B;MAC3B,mBAAmB;IACrB;EACF","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../../components/siteadmin/admin-common.css';\n@import '../../../components/helpers.css';\n\n\n.logInModalContainer {\n    max-width: 468px;\n    width: 100%;\n    margin: 160px auto;\n  }\n  \n  .modalPadding {\n    padding: 32px;\n  }\n  .paddingNone{\n    padding: 0 !important;\n  }\n  .modalGrid{\n    display: grid;\n    align-items: center;\n    word-break: break-word;\n    grid-template-columns: 40% 60%;\n    grid-column-gap: 8px;\n  }\n  @media screen and (max-width: 767px) {\n    .logInModalContainer {\n      margin: 0px auto;\n      padding: 10px;\n    }\n    .modalGrid{\n      grid-template-columns: 100%;\n      margin-bottom: 12px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `FailedPayoutOrRefundModal-commonHeaderAdmin-GKfxU`,
	"adminLayout": `FailedPayoutOrRefundModal-adminLayout-sKRO0`,
	"box": `FailedPayoutOrRefundModal-box-L6l2g`,
	"exportLink": `FailedPayoutOrRefundModal-exportLink-JHwR0`,
	"blockCenter": `FailedPayoutOrRefundModal-blockCenter-vBEE5`,
	"panelHeader": `FailedPayoutOrRefundModal-panelHeader-X8EoT`,
	"currencyselect": `FailedPayoutOrRefundModal-currencyselect-H_NO1`,
	"mar0": `FailedPayoutOrRefundModal-mar0-cwebm`,
	"sideAdminPageWrapper": `FailedPayoutOrRefundModal-sideAdminPageWrapper-gaQFf`,
	"table": `FailedPayoutOrRefundModal-table-V96TL`,
	"tableRow": `FailedPayoutOrRefundModal-tableRow-PRkGG`,
	"tableCell": `FailedPayoutOrRefundModal-tableCell-RFYXY`,
	"formGroup": `FailedPayoutOrRefundModal-formGroup-GpyNg`,
	"select": `FailedPayoutOrRefundModal-select-KMmZV`,
	"noMargin": `FailedPayoutOrRefundModal-noMargin-h5tqk`,
	"labelTextNew": `FailedPayoutOrRefundModal-labelTextNew-z8ATt`,
	"displayInline": `FailedPayoutOrRefundModal-displayInline-ygIen`,
	"btnUPdate": `FailedPayoutOrRefundModal-btnUPdate-ounIS`,
	"btnModalDelete": `FailedPayoutOrRefundModal-btnModalDelete-s8F7B`,
	"radioBtn": `FailedPayoutOrRefundModal-radioBtn-spJ3V`,
	"backgroundImg": `FailedPayoutOrRefundModal-backgroundImg-KHmip`,
	"btnWidth": `FailedPayoutOrRefundModal-btnWidth-KBftx`,
	"bannerImageBg": `FailedPayoutOrRefundModal-bannerImageBg-bDpHq`,
	"bannerDelete": `FailedPayoutOrRefundModal-bannerDelete-ZE1zT`,
	"modalRoot": `FailedPayoutOrRefundModal-modalRoot-ZSPfs`,
	"modalBorderBottom": `FailedPayoutOrRefundModal-modalBorderBottom-k_IlY`,
	"logInModalBody": `FailedPayoutOrRefundModal-logInModalBody-_LD24`,
	"exportSection": `FailedPayoutOrRefundModal-exportSection-hQFoz`,
	"exportSectionGridSub": `FailedPayoutOrRefundModal-exportSectionGridSub-K7Kie`,
	"exportText": `FailedPayoutOrRefundModal-exportText-dK1KZ`,
	"exportLinkImg": `FailedPayoutOrRefundModal-exportLinkImg-igvtr`,
	"vtrMiddle": `FailedPayoutOrRefundModal-vtrMiddle-iEXXa`,
	"exportImg": `FailedPayoutOrRefundModal-exportImg-srYoJ`,
	"profileViewlabel": `FailedPayoutOrRefundModal-profileViewlabel-BzODQ`,
	"profileViewMainContent": `FailedPayoutOrRefundModal-profileViewMainContent-vcTb9`,
	"profileViewMain": `FailedPayoutOrRefundModal-profileViewMain-l0X3y`,
	"profileViewInner": `FailedPayoutOrRefundModal-profileViewInner-HMC4A`,
	"profileImageSection": `FailedPayoutOrRefundModal-profileImageSection-fwu5f`,
	"lastviewInner": `FailedPayoutOrRefundModal-lastviewInner-I8QDW`,
	"whyHostHoriLine": `FailedPayoutOrRefundModal-whyHostHoriLine-mfzir`,
	"tableGrid": `FailedPayoutOrRefundModal-tableGrid-VaxQW`,
	"headingContent": `FailedPayoutOrRefundModal-headingContent-tAdf0`,
	"refundTextColor": `FailedPayoutOrRefundModal-refundTextColor-VPm43`,
	"dividerLine": `FailedPayoutOrRefundModal-dividerLine-sBqLP`,
	"smallContent": `FailedPayoutOrRefundModal-smallContent-sp0qF`,
	"ChangeToUpperCase": `FailedPayoutOrRefundModal-ChangeToUpperCase-Da0cF`,
	"noBorder": `FailedPayoutOrRefundModal-noBorder-cLwZe`,
	"siteAdminHeading": `FailedPayoutOrRefundModal-siteAdminHeading-IpHX4`,
	"siteAdminSubHeading": `FailedPayoutOrRefundModal-siteAdminSubHeading-RnCW_`,
	"adminFormDivider": `FailedPayoutOrRefundModal-adminFormDivider-W9rbW`,
	"space1": `FailedPayoutOrRefundModal-space1-livLO`,
	"space2": `FailedPayoutOrRefundModal-space2-lG3tE`,
	"space3": `FailedPayoutOrRefundModal-space3-oNlK9`,
	"space4": `FailedPayoutOrRefundModal-space4-zLWpP`,
	"space5": `FailedPayoutOrRefundModal-space5-zr4Gj`,
	"space6": `FailedPayoutOrRefundModal-space6-Im_wj`,
	"space7": `FailedPayoutOrRefundModal-space7-e1LKi`,
	"spaceTop8": `FailedPayoutOrRefundModal-spaceTop8-kyDZu`,
	"spaceTop1": `FailedPayoutOrRefundModal-spaceTop1-sBC_u`,
	"spaceTop2": `FailedPayoutOrRefundModal-spaceTop2-q0m5v`,
	"spaceTop3": `FailedPayoutOrRefundModal-spaceTop3-as0pA`,
	"spaceTop4": `FailedPayoutOrRefundModal-spaceTop4-yn4AQ`,
	"spaceTop5": `FailedPayoutOrRefundModal-spaceTop5-DbYk6`,
	"spaceTop6": `FailedPayoutOrRefundModal-spaceTop6-K1oOB`,
	"spaceTop7": `FailedPayoutOrRefundModal-spaceTop7-eR8Dh`,
	"padding1": `FailedPayoutOrRefundModal-padding1-LY88x`,
	"padding2": `FailedPayoutOrRefundModal-padding2-K9JSH`,
	"padding3": `FailedPayoutOrRefundModal-padding3-rfeQs`,
	"padding4": `FailedPayoutOrRefundModal-padding4-FVm41`,
	"padding5": `FailedPayoutOrRefundModal-padding5-HmNGI`,
	"padding6": `FailedPayoutOrRefundModal-padding6-ybtLU`,
	"padding7": `FailedPayoutOrRefundModal-padding7-zGhWM`,
	"paddingTop1": `FailedPayoutOrRefundModal-paddingTop1-iERL0`,
	"paddingTop2": `FailedPayoutOrRefundModal-paddingTop2-S9zZz`,
	"paddingTop3": `FailedPayoutOrRefundModal-paddingTop3-Fs5jD`,
	"paddingTop4": `FailedPayoutOrRefundModal-paddingTop4-YkSFL`,
	"paddingTop5": `FailedPayoutOrRefundModal-paddingTop5-eN5EH`,
	"paddingTop6": `FailedPayoutOrRefundModal-paddingTop6-yJfYF`,
	"paddingTop7": `FailedPayoutOrRefundModal-paddingTop7-vLlzi`,
	"noPadding": `FailedPayoutOrRefundModal-noPadding-YOiox`,
	"textBold": `FailedPayoutOrRefundModal-textBold-yw0Ev`,
	"textBolder": `FailedPayoutOrRefundModal-textBolder-F3mmm`,
	"textNormal": `FailedPayoutOrRefundModal-textNormal-Qym3k`,
	"spaceBottom20": `FailedPayoutOrRefundModal-spaceBottom20-xq_QU`,
	"spaceBottom10": `FailedPayoutOrRefundModal-spaceBottom10-UKIce`,
	"marginNone": `FailedPayoutOrRefundModal-marginNone-E_pUx`,
	"spaceBottom15": `FailedPayoutOrRefundModal-spaceBottom15-OaKWN`,
	"marginTopNone": `FailedPayoutOrRefundModal-marginTopNone-gcjb9`,
	"spaceTop11": `FailedPayoutOrRefundModal-spaceTop11-Dsqx0`,
	"spaceTop21": `FailedPayoutOrRefundModal-spaceTop21-f5lbj`,
	"spaceTop20": `FailedPayoutOrRefundModal-spaceTop20-ORuk2`,
	"spaceTop10": `FailedPayoutOrRefundModal-spaceTop10-dkMDO`,
	"textDarkBlue": `FailedPayoutOrRefundModal-textDarkBlue-MSgkK`,
	"textLightBlue": `FailedPayoutOrRefundModal-textLightBlue-An5JE`,
	"textLightSandleGreen": `FailedPayoutOrRefundModal-textLightSandleGreen-ifrAG`,
	"textLightBrown": `FailedPayoutOrRefundModal-textLightBrown-ssRRj`,
	"textMediumMaroon": `FailedPayoutOrRefundModal-textMediumMaroon-JEOyC`,
	"textBrown": `FailedPayoutOrRefundModal-textBrown-FgeuE`,
	"textMaroon": `FailedPayoutOrRefundModal-textMaroon-YAV1c`,
	"textDarkBrown": `FailedPayoutOrRefundModal-textDarkBrown-OP9GS`,
	"textMediumBrown": `FailedPayoutOrRefundModal-textMediumBrown-joLPE`,
	"textSkyBlue": `FailedPayoutOrRefundModal-textSkyBlue-ZrEVM`,
	"textGray": `FailedPayoutOrRefundModal-textGray-YrlCN`,
	"logInModalContainer": `FailedPayoutOrRefundModal-logInModalContainer-dq1ow`,
	"modalPadding": `FailedPayoutOrRefundModal-modalPadding-AYM5a`,
	"paddingNone": `FailedPayoutOrRefundModal-paddingNone-uSDHF`,
	"modalGrid": `FailedPayoutOrRefundModal-modalGrid-dyRIm`
};
module.exports = ___CSS_LOADER_EXPORT___;
